import { toast } from "react-toastify";

export const catchAsync = (func) => {
    return async (...args) => {
        try {
            const res = await func(...args);
            if (res.error) {
                throw new Error(res.error.message || res.error);
            }
            return res;
        } catch (error) {
            toast.error(error.message || "Something went wrong");
        }
    };
};

// Export blog API
export { default as blogAPI } from './blog';
